<div class="TotemWidgetChallenge TotemWidgetHScroll {{fullScreen ? 'TotemWidgetChallenge--FullScreen' : '' }}">
    @if (!fullScreen) {
        <div #locationsList class="TotemWidgetHScroll-List TotemWidgetChallenge-Locations" role="list">
            @for (group of locationGroups; track group.destination || group) {
                <div [attr.data-destination]="group.destination || null" role="listitem">
                    <div class="TotemWidgetChallenge-LocationCard card">
                        <div class="card-body">
                            @if (group.destination) {
                                <h5 class="TotemWidgetChallenge-LocationLabel text-primary text-center mb-3">
                                    <i class="fa-regular fa-location-dot me-2" aria-hidden="true"></i>
                                    <span>{{ group.destination }}</span>
                                </h5>
                            }
                            <div class="TotemWidgetChallenge-Summary {{ isAllCompleted(group) ? 'TotemWidgetChallenge-Summary--AllComplete' : '' }} d-flex justify-content-center align-items-center w-100 mb-3" role="img" [attr.aria-label]="getCompletedCount(group) + '/' + group.challenges.length">
                                <div>
                                    <div aria-hidden="true">
                                        {{getCompletedCount(group)}}/{{group.challenges.length}}
                                    </div>
                                    <svg height="100" width="100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                                        <circle cx="50%" cy="50%" [attr.stroke-dasharray]="getCircleStrokeDashArray(group)"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="d-flex TotemWidgetChallenge-List">
                                @for (challenge of group.challenges; track challenge.resultKey || challenge.id || challenge; let i = $index) {
                                    <div [style.transform]="'translate(-' + (group.challengeIndex * 100) + '%,0)'">
                                        <div class="TotemWidgetChallenge-Selector d-flex align-items-center mb-3">
                                            <div>
                                                <button type="button" class="btn btn-link" [disabled]="i <= 0" (click)="shiftChallenge(group, -1)" [attr.aria-label]="'totem-a11y.challenge-prev' | locTranslate">
                                                    <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                            <div>
                                                <h5 class="m-0" id="challenge-title-{{id}}-{{group.destination}}-{{i}}">{{ 'totem-widget-challenge.challenge-num' | locTranslate:'num':(i + 1) }}</h5>
                                            </div>
                                            <div>
                                                <button type="button" class="btn btn-link" [disabled]="i >= group.challenges.length - 1" (click)="shiftChallenge(group, 1)" [attr.aria-label]="'totem-a11y.challenge-next' | locTranslate">
                                                    <i class="fa-regular fa-chevron-right" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="TotemWidgetChallenge-Content" [attr.aria-labelledby]="'challenge-title-' + id + '-' + group.destination + '-' + i">
                                            @if (challenge.objective) {
                                                <div class="rounded bg-light p-3 d-flex mb-3">
                                                    <div>
                                                        <i class="fa-regular fa-lg fa-fw fa-trophy text-primary me-3" aria-hidden="true"></i>
                                                    </div>
                                                    <div>
                                                        <b>{{ 'totem-widget-challenge.objective' | locTranslate }}:</b> {{ challenge.objective }}
                                                    </div>
                                                </div>
                                            }
                                            <div class="rounded bg-light p-3 d-flex mb-3">
                                                <div>
                                                    <i class="fa-regular fa-lg fa-fw fa-list text-primary me-3" aria-hidden="true"></i>
                                                </div>
                                                <div>
                                                    <b>{{ 'totem-widget-challenge.mission' | locTranslate }}:</b> {{ challenge.mission }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="TotemWidgetChallenge-Check">
                                            <button type="button" class="btn btn-block btn-{{ challenge.checked ? 'success' : 'primary' }}" (click)="openChallenge(group, i)">
                                                <i class="fa-regular fa-{{ challenge.checked ? 'check' : 'play' }}" aria-hidden="true"></i>
                                                <span>{{ 'totem-widget-challenge.' + (challenge.checked ? 'challenge-completed' : 'take-up-challenge') | locTranslate }}</span>
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
    @if (fullScreen) {
        @if (challengeList[fullScreenParams]; as challenge) {
            <div class="card">
                <div class="card-body text-center">
                    <div>
                        <h5 class="mb-3" id="challenge-form-title-{{id}}">{{ 'totem-widget-challenge.challenge-num' | locTranslate:'num':getChallengeNumber(challenge) }}</h5>
                    </div>
                    <div class="TotemWidgetChallenge-Icon bg-primary text-white mb-3" aria-hidden="true">
                        <div>
                            <i class="fa-solid fa-{{ getChallengeIcon(challenge) }}"></i>
                        </div>
                    </div>
                    @if (challenge.destination) {
                        <div class="mb-2 text-muted">
                            <i class="fa-regular fa-location-dot me-1" aria-hidden="true"></i>
                            {{ challenge.destination }}
                        </div>
                    }
                    <div class="mb-3">
                        <div><b>{{ 'totem-widget-challenge.mission' | locTranslate }}</b></div>
                        <div>{{ challenge.mission }}</div>
                    </div>
                    <div class="TotemWidgetChallenge-Form">
                        @if (challenge.checked) {
                            @if (challenge.explanation) {
                                <div class="alert alert-light text-start mb-3">{{ challenge.explanation }}</div>
                            }
                            <button type="button" class="btn btn-block btn-success" (click)="goToNextChallenge()">
                                <span>{{ 'totem-widget-challenge.challenge-completed' | locTranslate }}</span>
                            </button>
                        }
                        @else if (challenge.type == 'photo') {
                            <label class="btn btn-block btn-primary position-relative mb-0">
                                <span>{{ 'totem-widget-challenge.upload-photo' | locTranslate }}</span>
                                <input type="file" accept="image/*" class="visually-hidden" [attr.aria-label]="'totem-widget-challenge.upload-photo' | locTranslate" (change)="completeChallenge(challenge, 'photo')">
                            </label>
                        }
                        @else if (challenge.type == 'checkin') {
                            @if (challenge.objective) {
                                <div class="mb-3 text-muted">{{ challenge.objective }}</div>
                            }
                            <button type="button" class="btn btn-block btn-primary" (click)="completeChallenge(challenge, 'checkin')">
                                <span>{{ 'totem-widget-challenge.submit-answer' | locTranslate }}</span>
                            </button>
                        }
                        @else if (challenge.type == 'multiple_choice' && challenge.options?.length) {
                            <div class="text-start mb-3">
                                @for (option of challenge.options; track option) {
                                    <button type="button" class="btn btn-block btn-outline-primary mb-2"
                                        (click)="completeChallenge(challenge, option, challenge.correctAnswer ? option === challenge.correctAnswer : undefined)">
                                        {{ option }}
                                    </button>
                                }
                            </div>
                        }
                        @else {
                            <label class="form-label visually-hidden" [attr.for]="'challenge-answer-' + id">{{ 'totem-a11y.challenge-answer' | locTranslate }}</label>
                            <textarea [id]="'challenge-answer-' + id" class="form-control mb-3" rows="4" [(ngModel)]="challenge.answer" [attr.aria-labelledby]="'challenge-form-title-' + id"></textarea>
                            <button type="button" class="btn btn-block btn-primary" [disabled]="!challenge.answer?.trim()" (click)="completeChallenge(challenge, challenge.answer)">
                                <span>{{ 'totem-widget-challenge.submit-answer' | locTranslate }}</span>
                            </button>
                        }
                    </div>
                </div>
            </div>
        }
    }
</div>
